<template>
  <transition
    :enter-active-class="slowAnimations ? 'enter-slower-active':'enter-active'"
    :leave-active-class="slowAnimations ? 'leave-slower-active':'leave-active'"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave"
  >
    <slot></slot>
  </transition>
</template>

<script>

export default {
  name: 'TransitionVerticalCollapse',
  props: ['slowAnimations'],
  methods: {
    beforeEnter (element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = '0px'
        }

        element.style.display = null
      })
    },
    enter (element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = `${element.scrollHeight}px`
        })
      })
    },
    afterEnter (element) {
      element.style.height = null
    },
    beforeLeave (element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `${element.offsetHeight}px`
        }
      })
    },
    leave (element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = '0px'
        })
      })
    },
    afterLeave (element) {
      element.style.height = null
    }
  }
}
</script>

<style scoped>
.enter-active,
.leave-active {
  overflow: hidden;
  transition: height 200ms ease-in-out;
}

.enter-slower-active,
.leave-slower-active {
  overflow: hidden;
  transition: height 1s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
}
</style>
